module.exports = __webpack_public_path__ + "static/media/house-day.b0948a55.svg";